import React from 'react'
import TextTruncate from 'react-text-truncate'
import useTranslation from '../hooks/UseTranslation'

const ShowMore = (props) => {
  const { t } = useTranslation()
  const [value, setValue] = React.useState(props.value)
  const [lines, setLines] = React.useState(props.lines)
  const [expanded, setExpanded] = React.useState(props.expanded)
  const [truncated, setTruncated] = React.useState()
  const [containerClass, setContainerClass] = React.useState(
    props.containerClass
  )

  React.useEffect(() => {
    setLines(props.lines)
  }, [props.lines])

  React.useEffect(() => {
    setValue(props.value)
  }, [props.value])

  React.useEffect(() => {
    setContainerClass(props.containerClass)
  }, [props.containerClass])

  const getBtn = (text) => (
    <span
      style={{ cursor: 'pointer' }}
      className={`font-weight-bold ${containerClass}`}
      onClick={() => setExpanded(!expanded)}
    >
      {text}
    </span>
  )

  return (
    <>
      <TextTruncate
        line={!expanded && lines}
        truncateText='...'
        text={value}
        textElement='p'
        onCalculated={console.log}
        onTruncated={setTruncated}
        containerClassName={`${expanded ? 'pre-wrap' : ''} ${containerClass}`}
        textTruncateChild={getBtn(t('show_more'))}
      />
      {!truncated && expanded && getBtn(t('show_less'))}
    </>
  )
}

export default ShowMore
